import css from "../css/modules/navigation.module.scss";
import { useSelector } from "react-redux";
import { RootStore } from "../redux";
import { useEffect, useState } from "react";
import { ErpConnectionTypes } from "../utils/constants";

export function HelpButton() {
  const locale = useSelector((state: RootStore) => state.i18nState.lang);
  const [helpUrl, setHelpUrl] = useState(`https://eu-manuals.ecisolutions.com/pa-index/#/index/${locale}/std`);
  const setting = useSelector((state: RootStore) => state.setting);

  useEffect(() => {
    let newHelpUrl = "";
    if (setting?.user?.erpConnectionType) {
      switch (setting?.user?.erpConnectionType) {
        case ErpConnectionTypes.RidderiQ: {
          newHelpUrl = `https://eu-manuals.ecisolutions.com/pa/#/index/${locale}/std`;
          break;
        }
        case ErpConnectionTypes.RidderiQApi: {
          newHelpUrl = `https://eu-manuals.ecisolutions.com/pa/#/index/${locale}/std`;
          break;
        }
        case ErpConnectionTypes.ProteusApi: {
          newHelpUrl = `https://eu-manuals.ecisolutions.com/pa-proteus/#/index/${locale}/std`;
          break;
        }
        case ErpConnectionTypes.BemetApi: {
          newHelpUrl = `https://eu-manuals.ecisolutions.com/pa-bemet/#/index/${locale}/std`;
          break;
        }     
        default: {
          newHelpUrl = `https://eu-manuals.ecisolutions.com/pa-index/#/index/${locale}/std`;
        }
      }
    } else {
      newHelpUrl = `https://eu-manuals.ecisolutions.com/pa-index/#/index/${locale}/std`
    }
    if (helpUrl !== newHelpUrl) {
      setHelpUrl(newHelpUrl);
    }
  }, [setting]);

  return (
    <a className={css.helpButton} href={helpUrl} lang={locale} target="_blank">
      <span className="ico icon-question-circle" />
    </a>
  );
}
